<template>
    <div class="flex w-full flex-col">
        <div class="flex w-full">
            <label
                v-if="label"
                class="relative px-2 text-xs"
            >
                {{ label }}
            </label>
            <RadioGroup v-model="inputValue">
                <RadioGroupLabel
                    v-if="label"
                    class="sr-only"
                >
                    {{ label }}
                </RadioGroupLabel>
                <div :class="optionsGroupClass">
                    <RadioGroupOption
                        v-for="(item, key) in options"
                        :key="key"
                        v-slot="{ active, checked }"
                        :data-cy="`radio-option-${key}`"
                        as="div"
                        :value="key"
                        class="radio group"
                    >
                        <slot v-bind="{ active: active, checked: checked, item: item }">
                            <div
                                class="radio-small-content"
                                :class="checked ? 'radio-checked' : 'radio-unchecked'"
                            >
                                <span class="radio-small-label">{{ item }}</span>
                            </div>
                        </slot>
                    </RadioGroupOption>
                </div>
            </RadioGroup>
        </div>
        <div
            v-if="errorMessage"
            class="my=auto mx-2 flex flex-shrink-0 text-center"
        >
            <div class="my-auto inline-flex text-xs text-red-500">
                <span class="my-auto">{{ errorMessage }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useField } from 'vee-validate';
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';
import { idGen } from '@/utilities/idGen';

const props = defineProps({
    options: {
        type: [Object, Array],
        required: false,
        default: () => ['Yes', 'No'],
    },
    label: {
        type: String,
        required: false,
        default: null,
    },
    vid: {
        type: String,
        required: false,
        default: () => idGen(6),
    },
    size: {
        type: String,
        required: false,
        default: 'sm',
    },
    rules: {
        type: null,
        default: null,
    },
    optionsGroupClass: {
        type: String,
        required: false,
        default: '',
    },
});

const { value: inputValue, errorMessage } = useField(props.vid, props.rules);
</script>
